import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import ScrollTop from 'components/ScrollTop';
import UserWatermark from 'components/UserWatermark';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { refreshUserContext } from 'services/userContextStore';
import { getToken } from 'services/http';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  // set media wise responsive drawer
  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  // 每次进入应用调用一次 /api/user_info 激活 admanager 组织上下文，
  // 并将可切换组织/角色缓存到本地供右上角切换器使用(失败不阻塞页面)。
  useEffect(() => {
    if (!getToken()) return;
    refreshUserContext().catch(() => {});
  }, []);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <ScrollTop />
      <Header />
      <Drawer />
      <UserWatermark />

      <Box
        component="main"
        sx={{
          width: 'calc(100% - 260px)',
          flexGrow: 1,
          p: isHome ? 0 : { xs: 2, sm: 2.5 },
          bgcolor: isHome ? '#FFFFFF' : 'transparent'
        }}
      >
        <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            px: 0,
            pt: isHome ? 0 : 0.5,
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Outlet />
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}
